import React from "react";

export default function EmptyScreen({ message }) {
  return (
    <div className="d-flex justify-content-center flex-column align-items-center rg-14 py-5 h-100 align-items-center w-100">
      <img
        src={
          require("../../Assets/Images/Components/Other/empty-screen.svg")
            .default
        }
        alt="Empty Screen"
      />
      <h5 className="mb-0 fs-18 text-black text-center ps-4 ">
        {message ? message : "No Records Found"}
      </h5>
    </div>
  );
}
